/**
 * Frontend runtime configuration. These are build-time env vars (Vite
 * inlines import.meta.env.VITE_* at build time) so the same bundle is
 * environment-specific per build - never hardcode account-specific values
 * here, only read them from the environment.
 */
export const appEnv = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '',
  cognitoUserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID ?? '',
  cognitoClientId: import.meta.env.VITE_COGNITO_CLIENT_ID ?? '',
  /** Minutes of inactivity before an admin session is force-signed-out. */
  inactivityTimeoutMinutes: 15,
};
